import Vue from 'vue';
import Overview from '../../general/overview-grid/overview';
import AdvancedSearch from './advanced-search';
import Grid from './grid';
import ExportFailureModal from './exportfailure-modal';

export default Vue.component('orderoverview', {
    extends: Overview,
    components:{
        'advancedsearch': AdvancedSearch,
        'grid': Grid
    },
    methods:{
        /** Builds the overview actions array */
        buildActions(){
            return [{ title: this.resources.actions.export, onclick: this.exportOrders, icon: 'si si-share-alt mr-2' }];
        },
        exportOrders(){
            var requestParameters = {
                pageSize: this.queryParameters.pageSize,
                totalRecordCount: this.pagination.totalRecordCount
            };

            this.axe.get('/canexportorders', { 
                    params: { paginationData: requestParameters }
                }).then((response) => {
                    if(response.data.openExportModal){
                        this.showExportModal(response.data);
                    } else {
                        window.location.href = response.data.exportUrl;
                    }
                }).catch((thrown) => {
                    console.log('app error', thrown.message);
                }).then(() => {
                    
                });
        },
        showExportModal(canExportOrdersData){
            this.$modal.show(ExportFailureModal, { 
                canExport: canExportOrdersData.canExport,
                resources: canExportOrdersData.resources
            }, {
                adaptive: true,
                height: 'auto',
                maxWidth: 300
            });
        }
    }
});